import { useEffect, useRef, useState } from 'react';
import debounce from 'lodash/debounce';
const isScrollingDown = (isBannerSticky, newScrollPosition, currentScrollPosition) => isBannerSticky && newScrollPosition > currentScrollPosition;
const isScrollingUpThanOffsetHeight = (isBannerSticky, newScrollPosition, currentScrollPosition, offsetHeight) => !isBannerSticky &&
    newScrollPosition < currentScrollPosition &&
    newScrollPosition > offsetHeight;
const useScrollToggle = (offsetHeight) => {
    const [isFixed, setIsFixed] = useState(true);
    const scrollState = useRef(0);
    useEffect(() => {
        const handleScroll = debounce(() => {
            const newScrollPosition = window.scrollY;
            setIsFixed(previousIsFixed => {
                // fallback set as true to void rare cases when page scroll bounces and cycles trigger latly
                if (newScrollPosition <= offsetHeight) {
                    return true;
                }
                if (isScrollingDown(previousIsFixed, newScrollPosition, scrollState.current)) {
                    return false;
                }
                if (isScrollingUpThanOffsetHeight(previousIsFixed, newScrollPosition, scrollState.current, offsetHeight)) {
                    return true;
                }
                return previousIsFixed;
            });
            scrollState.current = newScrollPosition;
        }, 20);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return isFixed;
};
export default useScrollToggle;
//# sourceMappingURL=useScrollToggle.js.map